import { Component } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';

@Component({
    selector: 'cv-schedule-advanced-options',
    templateUrl: './schedule-advanced-options.component.html',
    styleUrl: './schedule-advanced-options.component.scss'
})
export class ScheduleAdvancedOptionsComponent {
    rule: any = null;

    constructor(private gamesService: GamesService){
        this.rule = this.gamesService.data.modified.item.underlyingRule;
    }

    selectedDays(days: number) {
        this.rule.ActiveDays = days;
    }
}
